export default __webpack_public_path__ + "static/media/feeledLeave.17ff05af.svg";